export const localValidate = (formState) => {
  let hasRequiredField = false;
  let errors = {};

  if (formState.recordGroupId > 0) {
    hasRequiredField = true;
  }

  return errors;
};

const RecordsAdminSearchValidation = async (formState) => {
  let errors = localValidate(formState);

  return errors ? errors : {};
};

export default RecordsAdminSearchValidation;